var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { ref: "container" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("pleaseChoose")
                  },
                  on: { change: _vm.envIdChange },
                  model: {
                    value: _vm.paramsData.env_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "env_id", $$v)
                    },
                    expression: "paramsData.env_id"
                  }
                },
                _vm._l(_vm.szgmEnv, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("serverChannel")
                  },
                  on: { change: _vm.serverChange },
                  model: {
                    value: _vm.server_channel,
                    callback: function($$v) {
                      _vm.server_channel = $$v
                    },
                    expression: "server_channel"
                  }
                },
                _vm._l(_vm.serverChannel, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("showTestServer")
                  },
                  on: { change: _vm.serverChannelChange },
                  model: {
                    value: _vm.show_test,
                    callback: function($$v) {
                      _vm.show_test = $$v
                    },
                    expression: "show_test"
                  }
                },
                _vm._l(_vm.serverType, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("server")
                  },
                  on: { change: _vm.severChange },
                  model: {
                    value: _vm.paramsData.server_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "server_id", $$v)
                    },
                    expression: "paramsData.server_id"
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: { change: _vm.selectAll },
                      model: {
                        value: _vm.checked,
                        callback: function($$v) {
                          _vm.checked = $$v
                        },
                        expression: "checked"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("selectAll")) + " ")]
                  ),
                  _vm._l(_vm.serverListYJ, function(item) {
                    return _c("el-option", {
                      key: item.serverID,
                      attrs: { label: item.serverName, value: item.serverID }
                    })
                  })
                ],
                2
              )
            ],
            1
          ),
          _c("dataScreening", {
            attrs: {
              dataOptions: "pickerOptionsOnMonth",
              propsData: {
                isProduct: false,
                adChannel: false,
                adPlacement: false,
                isPayChannel: false,
                isCountry: false,
                isDate: false,
                isCurrency: true
              }
            },
            on: { searchChange: _vm.searchChange }
          }),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  filterable: "",
                  placeholder: _vm.$t("roleIdPlaceholder")
                },
                model: {
                  value: _vm.paramsData.role_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "role_id", $$v)
                  },
                  expression: "paramsData.role_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  filterable: "",
                  placeholder: _vm.$t("playerNickname")
                },
                model: {
                  value: _vm.paramsData.role_name,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "role_name", $$v)
                  },
                  expression: "paramsData.role_name"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  filterable: "",
                  placeholder: _vm.$t("account")
                },
                model: {
                  value: _vm.paramsData.account,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "account", $$v)
                  },
                  expression: "paramsData.account"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  filterable: "",
                  placeholder: _vm.$t("gatewayUserId")
                },
                model: {
                  value: _vm.paramsData.gate_user_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "gate_user_id", $$v)
                  },
                  expression: "paramsData.gate_user_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  filterable: "",
                  placeholder: _vm.$t("orderNumber")
                },
                model: {
                  value: _vm.paramsData.order_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "order_id", $$v)
                  },
                  expression: "paramsData.order_id"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticStyle: { width: "80px" } },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.exportLoadingt,
                    disabled: !_vm.searchList.length
                  },
                  on: { click: _vm.exportDtl }
                },
                [_vm._v(" " + _vm._s(_vm.$t("export")) + " ")]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "warning" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addExport.open()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("batchExport")) + " ")]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoadingOne },
                  on: {
                    click: function($event) {
                      return _vm.searchClick(1, true)
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("search")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoadingOne,
              expression: "reqLoadingOne"
            }
          ],
          staticClass: "marginB",
          attrs: { data: _vm.searchList, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "server_id",
              label: _vm.$t("serverId"),
              width: "100"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "role_name",
              label: _vm.$t("roleName"),
              width: "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "role_id",
              label: _vm.$t("roleId"),
              width: "150",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "text-ellipsis-1" }, [
                      _vm._v(" " + _vm._s(row.role_id) + " ")
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "account",
              label: _vm.$t("account"),
              width: "150",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "text-ellipsis-1" }, [
                      _vm._v(" " + _vm._s(row.account || "/") + " ")
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "gate_user_id",
              label: _vm.$t("gatewayUserId"),
              "show-overflow-tooltip": "",
              width: "330"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "text-ellipsis-1" }, [
                      _vm._v(" " + _vm._s(row.gate_user_id || "/") + " ")
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "phone",
              label: _vm.$t("phoneNumber"),
              width: "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "text-ellipsis-1" }, [
                      _vm._v(
                        " " +
                          _vm._s(row.phone ? row.phone : _vm.$t("unbound")) +
                          " "
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "level",
              label: _vm.$t("prestigeLevel"),
              width: "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "fighting",
              label: _vm.$t("totalPower"),
              width: "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "recharge_amount",
              label: _vm.$t("rechargeTotalAmount"),
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "real_time_amount",
              label: _vm.$t("realTimeRechargeAmount"),
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "third_login_type",
              label: _vm.$t("thirdPartyLoginType"),
              width: "150",
              "render-header": function(h, obj) {
                return _vm.renderheader(
                  h,
                  obj,
                  "normal:" +
                    _vm.$t("selfBuilt") +
                    ",apple:" +
                    _vm.$t("apple") +
                    ",google:" +
                    _vm.$t("google") +
                    ",facebook:" +
                    _vm.$t("facebook") +
                    ",guest:" +
                    _vm.$t("guest")
                )
              }
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "device_id",
              label: _vm.$t("recentLoginDeviceId"),
              width: "370"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "ext",
              label: _vm.$t("extendedParams"),
              width: "300",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "text-ellipsis-1" }, [
                      _vm._v(" " + _vm._s(row.ext || "/") + " ")
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "register_time",
              label: _vm.$t("registerTime"),
              width: "200"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "last_login_time",
              label: _vm.$t("recentLoginTime"),
              width: "200"
            }
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("operation"), width: "250", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.viewDetail(row)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("view")))]
                      ),
                      _c("div", { staticClass: "controlsBtn-vertical" }),
                      row.ban_info == 0
                        ? _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function() {
                                  _vm.popData = row
                                  _vm.$refs.addEmperor.open(
                                    { uid: row.role_id },
                                    false
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("banAccount")))]
                          )
                        : _vm._e(),
                      row.ban_info == 1
                        ? _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function() {
                                  _vm.popData = row
                                  _vm.$refs.unseal.open({ uid: row.role_id })
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("unban")))]
                          )
                        : _vm._e(),
                      _c("div", { staticClass: "controlsBtn-vertical" }),
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function() {
                              _vm.popData = row
                              _vm.$refs.draft.openWithServerChannel(
                                _vm.serverChannel,
                                {},
                                row.role_id
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("sendMail")))]
                      ),
                      _c("div", { staticClass: "controlsBtn-vertical" }),
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.$refs.bindPhone.open(row)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("phoneNumber")))]
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          layout: "total,sizes, prev, pager, next",
          "current-page": _vm.paramsData.page,
          total: _vm.total
        },
        on: {
          "current-change": function($event) {
            return _vm.searchClick($event, false)
          },
          "size-change": function($event) {
            return _vm.searchClickSizeChange($event, false)
          }
        }
      }),
      _vm.detailsData.length
        ? _c(
            "div",
            [
              _c(
                "el-table",
                {
                  staticClass: "marginB",
                  attrs: { data: _vm.detailsData, border: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "role_name",
                      label: _vm.$t("roleName"),
                      "min-width": "180"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "user_id",
                      label: _vm.$t("userId"),
                      "min-width": "180"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "account",
                      label: _vm.$t("account"),
                      width: "150",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              _c("div", { staticClass: "text-ellipsis-1" }, [
                                _vm._v(" " + _vm._s(row.account || "/") + " ")
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3022683586
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "gate_user_id",
                      label: _vm.$t("gatewayUserId"),
                      "show-overflow-tooltip": "",
                      width: "330"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              _c("div", { staticClass: "text-ellipsis-1" }, [
                                _vm._v(" " + _vm._s(row.gate_user_id) + " ")
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2558494759
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "level",
                      label: _vm.$t("prestigeLevel"),
                      "min-width": "110"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fighting",
                      label: _vm.$t("totalPower"),
                      "min-width": "110"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "league_name",
                      label: _vm.$t("alliance"),
                      "min-width": "160",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "recharge_amount",
                      label: _vm.$t("rechargeTotalAmount"),
                      "min-width": "150"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "real_time_amount",
                      label: _vm.$t("realTimeRechargeAmount"),
                      "min-width": "150"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "remain_coin",
                      label: _vm.$t("spiritCrystalCount"),
                      "min-width": "110"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "remain_diamond",
                      label: _vm.$t("immortalJadeCount"),
                      "min-width": "110"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "relevancy_role_name",
                      label: _vm.$t("associatedAccount"),
                      "min-width": "160",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "text-ellipsis-1",
                                  staticStyle: { cursor: "pointer" }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(row.relevancy_role_name || "/") +
                                      " "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3985923001
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "channel",
                      label: _vm.$t("channel"),
                      "min-width": "120"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(row.channel_name || row.channel) +
                                  " "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4013907267
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "last_login_country",
                      label: _vm.$t("recentLoginRegion"),
                      "min-width": "140"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "device_id",
                      label: _vm.$t("recentLoginDeviceId"),
                      width: "370"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    row.last_logins
                                      ? row.last_logins.device_id
                                      : "/"
                                  ) +
                                  " "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2441257813
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ext",
                      label: _vm.$t("extendedParams"),
                      width: "300",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              _c("div", { staticClass: "text-ellipsis-1" }, [
                                _vm._v(" " + _vm._s(row.ext || "/") + " ")
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1503039050
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "register_country",
                      label: _vm.$t("registerCountry"),
                      "min-width": "140"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "register_time",
                      label: _vm.$t("registerTime"),
                      width: _vm.$utils.flexColumnWidth(
                        "2023-12-05 14:56:43",
                        false
                      )
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "last_login_time",
                      label: _vm.$t("recentLoginTime"),
                      "min-width": "210"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "country",
                      label: _vm.$t("country"),
                      "min-width": "180"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ip",
                      label: _vm.$t("ipAddress"),
                      "min-width": "140"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "worldBossScore",
                      label: _vm.$t("worldBossScore"),
                      "min-width": "140"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "worldBossDamage",
                      label: _vm.$t("worldBossDamage"),
                      "min-width": "140"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "roleBattleScore",
                      label: _vm.$t("townEvilAncientDomainScore"),
                      "min-width": "140"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pvpScore",
                      label: _vm.$t("pvpScore"),
                      "min-width": "140"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        height: "100%"
                      },
                      attrs: { span: 4.5 }
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "mini" },
                          on: { change: _vm.handleCheckedCitiesChange },
                          model: {
                            value: _vm.checkedCities,
                            callback: function($$v) {
                              _vm.checkedCities = $$v
                            },
                            expression: "checkedCities"
                          }
                        },
                        _vm._l(_vm.featureList, function(item, index) {
                          return _c(
                            "el-radio-button",
                            {
                              key: index,
                              attrs: { label: item.id, border: "" }
                            },
                            [_vm._v(_vm._s(item.title))]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm.checkedCities != "2"
                    ? _c(
                        "el-col",
                        { staticStyle: { width: "260px" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              "picker-options": _vm.pickerOptionsRadius,
                              "value-format": "yyyy-MM-dd",
                              clearable: false,
                              type: "daterange",
                              align: "right",
                              "range-separator": _vm.$t("range"),
                              "start-placeholder": _vm.$t("startDate"),
                              "end-placeholder": _vm.$t("endDate")
                            },
                            on: { change: _vm.dataChange },
                            model: {
                              value: _vm.date,
                              callback: function($$v) {
                                _vm.date = $$v
                              },
                              expression: "date"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkedCities == "2"
                    ? _c(
                        "el-col",
                        { staticStyle: { width: "260px" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              "picker-options": _vm.pickerOptionsRadius,
                              "value-format": "yyyy-MM-dd",
                              clearable: false,
                              type: "daterange",
                              align: "right",
                              "range-separator": _vm.$t("range"),
                              "start-placeholder": _vm.$t("startDate"),
                              "end-placeholder": _vm.$t("endDate")
                            },
                            on: { change: _vm.dataChange },
                            model: {
                              value: _vm.singledate,
                              callback: function($$v) {
                                _vm.singledate = $$v
                              },
                              expression: "singledate"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkedCities == "2"
                    ? _c(
                        "el-col",
                        { staticStyle: { width: "260px" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              filterable: "",
                              placeholder: _vm.$t("outputItemName")
                            },
                            model: {
                              value: _vm.propertyparamsData.output,
                              callback: function($$v) {
                                _vm.$set(_vm.propertyparamsData, "output", $$v)
                              },
                              expression: "propertyparamsData.output"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkedCities == "2"
                    ? _c(
                        "el-col",
                        { staticStyle: { width: "260px" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              filterable: "",
                              placeholder: _vm.$t("consumptionItemName")
                            },
                            model: {
                              value: _vm.propertyparamsData.cost,
                              callback: function($$v) {
                                _vm.$set(_vm.propertyparamsData, "cost", $$v)
                              },
                              expression: "propertyparamsData.cost"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkedCities == "2"
                    ? _c(
                        "el-col",
                        { staticStyle: { width: "260px" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              filterable: "",
                              placeholder: _vm.$t("operationName")
                            },
                            model: {
                              value: _vm.propertyparamsData.action,
                              callback: function($$v) {
                                _vm.$set(_vm.propertyparamsData, "action", $$v)
                              },
                              expression: "propertyparamsData.action"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkedCities == "2" && _vm.property.length
                    ? _c(
                        "el-col",
                        { staticStyle: { width: "100px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                loading: _vm.exportdataDealoading
                              },
                              on: { click: _vm.exportproperty }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("export")) + " ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkedCities == "3" && _vm.searchCurrency.length
                    ? _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: _vm.$t("pleaseSelectCurrencyType")
                              },
                              model: {
                                value: _vm.orderparamsData.currency_info,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.orderparamsData,
                                    "currency_info",
                                    $$v
                                  )
                                },
                                expression: "orderparamsData.currency_info"
                              }
                            },
                            _vm._l(_vm.searchCurrency, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.currency_name,
                                  value: item.currency
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkedCities == "3" && _vm.orderData.length
                    ? _c(
                        "el-col",
                        { staticStyle: { width: "100px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                loading: _vm.exportLoading
                              },
                              on: { click: _vm.exportdata }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("exportAll")) + " ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkedCities == "7"
                    ? _c(
                        "el-col",
                        { staticStyle: { width: "260px" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              filterable: "",
                              placeholder: _vm.$t("itemId")
                            },
                            model: {
                              value: _vm.bagRetainparamsData.desc_name,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.bagRetainparamsData,
                                  "desc_name",
                                  $$v
                                )
                              },
                              expression: "bagRetainparamsData.desc_name"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkedCities == "7" && _vm.bgTableCopyTableList.length
                    ? _c(
                        "el-col",
                        { staticStyle: { width: "100px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                loading: _vm.exportLoading
                              },
                              on: { click: _vm.exportBagdata }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("export")) + " ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkedCities == "8"
                    ? _c(
                        "el-col",
                        { staticStyle: { width: "260px" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              filterable: "",
                              placeholder: _vm.$t("equipmentId")
                            },
                            model: {
                              value: _vm.equipmentparamsData.equip,
                              callback: function($$v) {
                                _vm.$set(_vm.equipmentparamsData, "equip", $$v)
                              },
                              expression: "equipmentparamsData.equip"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkedCities == "8"
                    ? _c(
                        "el-col",
                        { staticStyle: { width: "260px" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              filterable: "",
                              placeholder: _vm.$t("outputResourceId")
                            },
                            model: {
                              value: _vm.equipmentparamsData.output,
                              callback: function($$v) {
                                _vm.$set(_vm.equipmentparamsData, "output", $$v)
                              },
                              expression: "equipmentparamsData.output"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkedCities == "8"
                    ? _c(
                        "el-col",
                        { staticStyle: { width: "260px" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              filterable: "",
                              placeholder: _vm.$t("consumptionResourceId")
                            },
                            model: {
                              value: _vm.equipmentparamsData.cost,
                              callback: function($$v) {
                                _vm.$set(_vm.equipmentparamsData, "cost", $$v)
                              },
                              expression: "equipmentparamsData.cost"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkedCities != "5"
                    ? _c(
                        "el-col",
                        { attrs: { span: 1 } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                loading: _vm.reqLoadingTow
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleCheckedCitiesChange(
                                    _vm.checkedCities
                                  )
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("search")) + " ")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.checkedCities == "1"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          key: "ksajaiqsasrfr",
                          attrs: { data: _vm.tableData, border: "" }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "ad_channel_reveal",
                              label: _vm.$t("adPlatform"),
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "ad_placement_reveal",
                              label: _vm.$t("adPosition"),
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "server_id",
                              label: _vm.$t("serverId"),
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "device_id",
                              label: _vm.$t("deviceId"),
                              "show-overflow-tooltip": "",
                              width: "360"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "user_id",
                              label: _vm.$t("userId"),
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "role_id",
                              label: _vm.$t("roleId"),
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "name",
                              label: _vm.$t("roleName"),
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "desc_kind",
                              label: _vm.$t("itemType"),
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "desc_name",
                              label: _vm.$t("itemName"),
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "num",
                              label: _vm.$t("itemQuantity"),
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "last_update_time",
                              label: _vm.$t("updateTime"),
                              "show-overflow-tooltip": "",
                              width: "180"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$times.timestampToTime(
                                              row.last_update_time,
                                              "YY-MM-DD HH"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2567600880
                            )
                          })
                        ],
                        1
                      ),
                      _c("el-pagination", {
                        attrs: {
                          layout: "total,sizes, prev, pager, next",
                          "current-page": _vm.currentPage,
                          total: _vm.tableCopyTableList.length,
                          "page-size": _vm.pageSize
                        },
                        on: {
                          "current-change": _vm.handleCurrentChange1,
                          "size-change": _vm.backSizeChange
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.checkedCities == "2"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.reqLoadingTow,
                              expression: "reqLoadingTow"
                            }
                          ],
                          key: "sdkjaoqiweq",
                          attrs: { data: _vm.property, border: "" }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { prop: "user_id", label: _vm.$t("userId") }
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "role_id", label: _vm.$t("roleId") },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { cursor: "pointer" },
                                          on: {
                                            click: function($event) {
                                              return _vm.gotoEquipItem(
                                                scope.row
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row.role_id) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1877854102
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "device_id_str",
                              label: _vm.$t("deviceId"),
                              width: "360"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "ext", label: _vm.$t("ext") }
                          }),
                          _c("el-table-column", {
                            attrs: { label: _vm.$t("consumption") },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return _vm._l(
                                      scope.row.resource.cost,
                                      function(item, index) {
                                        return _c("div", { key: index }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(item.item_name) +
                                              ":" +
                                              _vm._s(item.item_num) +
                                              " "
                                          )
                                        ])
                                      }
                                    )
                                  }
                                }
                              ],
                              null,
                              false,
                              4233693968
                            )
                          }),
                          _c("el-table-column", {
                            attrs: { label: _vm.$t("output") },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return _vm._l(
                                      scope.row.resource.output,
                                      function(item, index) {
                                        return _c("div", { key: index }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(item.item_name) +
                                              ":" +
                                              _vm._s(item.item_num) +
                                              " "
                                          )
                                        ])
                                      }
                                    )
                                  }
                                }
                              ],
                              null,
                              false,
                              2065771204
                            )
                          }),
                          _c("el-table-column", {
                            attrs: { label: _vm.$t("retention") },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return _vm._l(
                                      scope.row.resource.retain,
                                      function(item, index) {
                                        return _c("div", { key: index }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(item.item_name) +
                                              ":" +
                                              _vm._s(item.item_num) +
                                              " "
                                          )
                                        ])
                                      }
                                    )
                                  }
                                }
                              ],
                              null,
                              false,
                              1385690622
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "action",
                              label: _vm.$t("operation")
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "action_name",
                              label: _vm.$t("operationName")
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "time",
                              label: _vm.$t("time"),
                              width: "200"
                            }
                          })
                        ],
                        1
                      ),
                      _c("el-pagination", {
                        attrs: {
                          layout: "total,sizes, prev, pager, next",
                          "current-page": _vm.propertyparamsData.page,
                          total: _vm.propertyTotal
                        },
                        on: {
                          "current-change": _vm.propertyhandleCurrentChange,
                          "size-change":
                            _vm.propertyhandleCurrentChangeSizeChange
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.checkedCities == "3"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.reqLoadingTow,
                              expression: "reqLoadingTow"
                            }
                          ],
                          key: "sdjkahdsja",
                          attrs: { data: _vm.orderData, border: "" }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "ad_channel_reveal",
                              label: _vm.$t("adChannel"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "ad_placement_reveal",
                              label: _vm.$t("adPosition"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "country",
                              label: _vm.$t("country"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "order_id",
                              label: _vm.$t("devOrderId"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "pay_channel_order_id",
                              label: _vm.$t("channelOrderId"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "user_id",
                              label: _vm.$t("userId"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "role_id",
                              label: _vm.$t("roleId"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "device_id",
                              label: _vm.$t("deviceId"),
                              "show-overflow-tooltip": "",
                              "min-width": "360"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "amount",
                              label: _vm.$t("paymentAmount"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$utils
                                              .conversion(row.amount)
                                              .toFixed(2)
                                          ) +
                                          " "
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2165437223
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "product_id",
                              label: _vm.$t("rechargeProductId"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "product_name",
                              label: _vm.$t("rechargeProductName"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "timestamp",
                              label: _vm.$t("rechargeTime"),
                              "show-overflow-tooltip": "",
                              "min-width": "200"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "ip",
                              label: _vm.$t("ipAddress"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          })
                        ],
                        1
                      ),
                      _c("el-pagination", {
                        attrs: {
                          layout: "total,sizes, prev, pager, next",
                          "current-page": _vm.orderparamsData.page,
                          total: _vm.orderTotal
                        },
                        on: {
                          "current-change": _vm.orderhandleCurrentChange,
                          "size-change": _vm.orderhandleCurrentChangeSizeChange
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.checkedCities == "4"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.reqLoadingTow,
                              expression: "reqLoadingTow"
                            }
                          ],
                          key: "asasikdjq",
                          attrs: { data: _vm.emailList, border: "" }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "id",
                              label: _vm.$t("id"),
                              "min-width": "80"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "sender",
                              label: _vm.$t("sender"),
                              "min-width": "100"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "text-ellipsis-1" },
                                        [_vm._v(_vm._s(row.sender))]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3402713671
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "title",
                              label: _vm.$t("mailTitle"),
                              "min-width": "180",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "text-ellipsis-1" },
                                        [_vm._v(_vm._s(row.title))]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2128057068
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "email_type",
                              label: _vm.$t("mailType"),
                              "min-width": "120"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.emailType.find(function(item) {
                                              return (
                                                item.value == row.email_type
                                              )
                                            }).label
                                          ) +
                                          " "
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              603777189
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "reward",
                              label: _vm.$t("mailAttachment"),
                              "min-width": "100"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            color: "#409EFF",
                                            cursor: "pointer"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.$refs.viewArticles.init(
                                                row.reward
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("view")))]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2641011135
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "language",
                              label: _vm.$t("language"),
                              "min-width": "100"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.Language.filter(function(item) {
                                              return item.value == row.language
                                            })[0].label
                                          ) +
                                          " "
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1598020169
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "email_user_ids",
                              label: _vm.$t("targetAccount"),
                              "min-width": "160",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "text-ellipsis-1",
                                          staticStyle: { width: "140px" }
                                        },
                                        [_vm._v(_vm._s(row.email_user_ids))]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              4143997457
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "times",
                              label: _vm.$t("generatedAccountTimeRange"),
                              "min-width": "220"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "created_at",
                              label: _vm.$t("addTime"),
                              "min-width": "180"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$times.formDate(row.created_at)
                                          ) +
                                          " "
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              724052954
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "expire",
                              label: _vm.$t("expirationTime"),
                              "min-width": "180"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "expire", label: _vm.$t("details") },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            color: "#409EFF",
                                            cursor: "pointer"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.$refs.emailDetils.init(
                                                row
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("view")))]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              362264627
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "expire",
                              label: _vm.$t("mailStatus"),
                              "min-width": "250"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      row.state == 2 && row.delay_state == 2
                                        ? _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("normalTaskNotSent")
                                              )
                                            )
                                          ])
                                        : _vm._e(),
                                      row.state == 2 && row.delay_state == 1
                                        ? _c("div", [
                                            _vm._v(
                                              _vm._s(_vm.$t("scheduledSend")) +
                                                " " +
                                                _vm._s(
                                                  _vm.$times.timestampToTime(
                                                    row.delay_time,
                                                    "YY-MM-DD hh:mm:ss"
                                                  )
                                                )
                                            )
                                          ])
                                        : _vm._e(),
                                      (row.state == 1 &&
                                        row.delay_state == 1) ||
                                      (row.state == 1 && row.delay_state == 2)
                                        ? _c("div", [
                                            _vm._v(
                                              _vm._s(_vm.$t("sent")) +
                                                " " +
                                                _vm._s(
                                                  _vm.$times.timestampToTime(
                                                    row.send_time,
                                                    "YY-MM-DD hh:mm:ss"
                                                  )
                                                )
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              982039654
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.checkedCities == "5"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                height: "100%"
                              },
                              attrs: { span: 4.5 }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  attrs: { size: "mini" },
                                  on: { change: _vm.operationLogChange },
                                  model: {
                                    value: _vm.controlsSortIndex,
                                    callback: function($$v) {
                                      _vm.controlsSortIndex = $$v
                                    },
                                    expression: "controlsSortIndex"
                                  }
                                },
                                _vm._l(_vm.controlsSort, function(item, index) {
                                  return _c(
                                    "el-radio-button",
                                    {
                                      key: index,
                                      attrs: { label: index, border: "" }
                                    },
                                    [_vm._v(_vm._s(item.title))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 1 } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    height: "28px",
                                    "line-height": "12px"
                                  },
                                  attrs: {
                                    type: "primary",
                                    loading: _vm.reqLoadingTow,
                                    size: "mini"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.operationLogChange(
                                        _vm.controlsSortIndex
                                      )
                                    }
                                  }
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("search")) + " ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.controlsSortIndex == 0
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-table",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.reqLoadingTow,
                                      expression: "reqLoadingTow"
                                    }
                                  ],
                                  key: "asaewqw1dc",
                                  attrs: {
                                    data: _vm.controlsSort[0].list,
                                    border: ""
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "admin_name",
                                      label: _vm.$t("operator")
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    row.admin_name || "/"
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3883411047
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "uid",
                                      label: _vm.$t("gameUid")
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "order_id",
                                      label: _vm.$t("orderId"),
                                      width: "370"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "pay_channel_order_id",
                                      label: _vm.$t("paymentChannelOrder")
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "product_id",
                                      label: _vm.$t("productId")
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "pay_type",
                                      label: _vm.$t("paymentMethod")
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.payType.find(function(
                                                      i
                                                    ) {
                                                      return (
                                                        i.value == row.pay_type
                                                      )
                                                    }).label
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2570089508
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "reward",
                                      label: _vm.$t("item"),
                                      "min-width": "100"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    color: "#409EFF",
                                                    cursor: "pointer"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.$refs.viewArticles.init(
                                                        row.reward
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(_vm.$t("view")))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2641011135
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "expire_time",
                                      label: _vm.$t("replenishmentTime")
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$times.timestampToTime(
                                                      row.created_at,
                                                      "YY-MM-DD HH"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2699609748
                                    )
                                  })
                                ],
                                1
                              ),
                              _c("el-pagination", {
                                attrs: {
                                  layout: "total,sizes, prev, pager, next",
                                  "current-page": _vm.controlsSort[0].page,
                                  total: _vm.controlsSort[0].total
                                },
                                on: {
                                  "current-change": function($event) {
                                    return _vm.handleCurrentChange($event, 0)
                                  },
                                  "size-change": function($event) {
                                    return _vm.handleCurrentChangeSizeChange(
                                      $event,
                                      0
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.controlsSortIndex == 1
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-table",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.reqLoadingTow,
                                      expression: "reqLoadingTow"
                                    }
                                  ],
                                  key: "lsaisnhds",
                                  attrs: {
                                    data: _vm.controlsSort[1].list,
                                    border: ""
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "admin_name",
                                      label: _vm.$t("operator")
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    row.admin_name || "/"
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3883411047
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "uid",
                                      label: _vm.$t("playerId")
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "op_type",
                                      label: _vm.$t("operation")
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    row.status == 2
                                                      ? _vm.$t("unban")
                                                      : _vm.$t("ban")
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3658543207
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "expire_time",
                                      label: _vm.$t("banATime")
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    row.status == 2
                                                      ? "/"
                                                      : row.expire_time == 0
                                                      ? _vm.$t("permanentBan")
                                                      : _vm.$times.timestampToTime(
                                                          row.expire_time,
                                                          "YY-MM-DD HH"
                                                        )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3123881921
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "expire_time",
                                      label: _vm.$t("operationTime")
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$times.timestampToTime(
                                                      row.time,
                                                      "YY-MM-DD HH"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      513827243
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "reason",
                                      label: _vm.$t("operationReason"),
                                      width: "600",
                                      "show-overflow-tooltip": ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(row.reason || "/") +
                                                  " "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2917784532
                                    )
                                  })
                                ],
                                1
                              ),
                              _c("el-pagination", {
                                attrs: {
                                  layout: "total,sizes, prev, pager, next",
                                  "current-page": _vm.controlsSort[1].page,
                                  total: _vm.controlsSort[1].total
                                },
                                on: {
                                  "current-change": function($event) {
                                    return _vm.handleCurrentChange($event, 1)
                                  },
                                  "size-change": function($event) {
                                    return _vm.handleCurrentChangeSizeChange(
                                      $event,
                                      1
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.controlsSortIndex == 2
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-table",
                                {
                                  key: "asaewqdfdfw",
                                  attrs: {
                                    data: _vm.controlsSort[2].list,
                                    border: ""
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "admin_name",
                                      label: _vm.$t("operator")
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _c("div", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      row.admin_name || "/"
                                                    ) +
                                                    " "
                                                )
                                              ])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      620019531
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "expire",
                                      label: _vm.$t("banATime")
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    row.expire == 0
                                                      ? _vm.$t("permanentBan")
                                                      : _vm.$times.timestampToTime(
                                                          row.expire,
                                                          "YY-MM-DD HH"
                                                        )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2507039817
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "reason",
                                      label: _vm.$t("remark"),
                                      "show-overflow-tooltip": ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "text-ellipsis-1"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        row.reason || "/"
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2718878951
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "created_at",
                                      label: _vm.$t("operationTime")
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    row.created_at
                                                      ? _vm.$times.formDate(
                                                          row.created_at,
                                                          "YY-MM-DD HH"
                                                        )
                                                      : "/"
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3524612050
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.checkedCities == "6"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.reqLoadingTow,
                              expression: "reqLoadingTow"
                            }
                          ],
                          key: "wfefa",
                          attrs: { data: _vm.loginList, border: "" }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "ad_channel",
                              label: _vm.$t("adChannel"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "ad_placement",
                              label: _vm.$t("adPosition"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "platform",
                              label: _vm.$t("platform"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "time",
                              label: _vm.$t("time"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "role_id",
                              label: _vm.$t("roleId"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "ip",
                              label: _vm.$t("ipAddress"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.checkedCities == "7"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.reqLoadingTow,
                              expression: "reqLoadingTow"
                            }
                          ],
                          key: "wfefa",
                          attrs: { data: _vm.bagRetainList, border: "" }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { prop: "date", label: _vm.$t("date") }
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "game", label: _vm.$t("game") }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "platform",
                              label: _vm.$t("platform")
                            }
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "channel", label: _vm.$t("channel") }
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "pkg", label: _vm.$t("packageName") }
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "role_id", label: _vm.$t("roleId") }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "server_name",
                              label: _vm.$t("serverName")
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "role_name",
                              label: _vm.$t("playerName")
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "item_name",
                              label: _vm.$t("itemNameLabel")
                            }
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "item_id", label: _vm.$t("itemId") }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "total_num",
                              label: _vm.$t("quantity")
                            }
                          })
                        ],
                        1
                      ),
                      _c("el-pagination", {
                        attrs: {
                          layout: "total,sizes, prev, pager, next",
                          "current-page": _vm.bgCurrentPage,
                          total: _vm.bgTableCopyTableList.length,
                          "page-size": _vm.bgPageSize
                        },
                        on: {
                          "size-change": _vm.bgHandleSizeChange,
                          "current-change": _vm.bgHandleCurrentChange
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.checkedCities == "8"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.reqLoadingTow,
                              expression: "reqLoadingTow"
                            }
                          ],
                          key: "233sefr45",
                          attrs: {
                            data: _vm.equipmentData,
                            border: "",
                            "max-height": "600px"
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { prop: "user_id", label: _vm.$t("userId") }
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "role_id", label: _vm.$t("roleId") }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "device_id",
                              label: _vm.$t("deviceId")
                            }
                          }),
                          _c("el-table-column", {
                            attrs: { label: _vm.$t("equipment") },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return _vm._l(
                                      scope.row.equipments,
                                      function(item, index) {
                                        return _c("div", { key: index }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.item_name +
                                                  "-" +
                                                  item.quality
                                              ) +
                                              ":" +
                                              _vm._s(item.num) +
                                              " "
                                          )
                                        ])
                                      }
                                    )
                                  }
                                }
                              ],
                              null,
                              false,
                              2660070071
                            )
                          }),
                          _c("el-table-column", {
                            attrs: { label: _vm.$t("consumption") },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return _vm._l(scope.row.costs, function(
                                      item,
                                      index
                                    ) {
                                      return _c("div", { key: index }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(item.item_name) +
                                            ":" +
                                            _vm._s(item.num) +
                                            " "
                                        )
                                      ])
                                    })
                                  }
                                }
                              ],
                              null,
                              false,
                              1647470285
                            )
                          }),
                          _c("el-table-column", {
                            attrs: { label: _vm.$t("output") },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return _vm._l(scope.row.outputs, function(
                                      item,
                                      index
                                    ) {
                                      return _c("div", { key: index }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(item.item_name) +
                                            ":" +
                                            _vm._s(item.num) +
                                            " "
                                        )
                                      ])
                                    })
                                  }
                                }
                              ],
                              null,
                              false,
                              3896829977
                            )
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "time", label: _vm.$t("time") }
                          })
                        ],
                        1
                      ),
                      _c("el-pagination", {
                        attrs: {
                          layout: "total,sizes, prev, pager, next",
                          "current-page": _vm.equipmentparamsData.page,
                          total: _vm.equipmentTotal
                        },
                        on: {
                          "current-change": _vm.equipmenthandleCurrentChange,
                          "size-change":
                            _vm.equipmenthandleCurrentChangeSizeChange
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c("draft", {
        ref: "draft",
        attrs: {
          propsData: {
            server_id: _vm.popData.server_id,
            env_id: _vm.paramsData.env_id
          }
        }
      }),
      _c("addEmperor", {
        ref: "addEmperor",
        attrs: {
          propsData: {
            server_id: _vm.popData.server_id,
            env_id: _vm.paramsData.env_id
          }
        },
        on: { change: _vm.addEmperorChange }
      }),
      _c("unseal", {
        ref: "unseal",
        attrs: {
          propsData: {
            server_id: _vm.popData.server_id,
            env_id: _vm.paramsData.env_id
          }
        },
        on: { change: _vm.addEmperorChange }
      }),
      _c("viewArticles", { ref: "viewArticles" }),
      _c("emailDetils", { ref: "emailDetils" }),
      _c("bindPhone", {
        ref: "bindPhone",
        on: {
          change: function($event) {
            return _vm.searchClick(1, true)
          }
        }
      }),
      _c("addExport", {
        ref: "addExport",
        attrs: {
          prod: {
            env_id: _vm.paramsData.env_id,
            game_id: _vm.rawData.game_id,
            currency_info: _vm.defaultData().currency_info
          },
          serverList: _vm.serverListYJ
        }
      }),
      _c(
        "el-drawer",
        {
          attrs: { title: _vm.$t("details"), visible: _vm.isCode },
          on: {
            "update:visible": function($event) {
              _vm.isCode = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "10px 20px 0", position: "relative" } },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.codeLists, border: "" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "expire",
                      label: _vm.$t("time"),
                      width: "200"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$times.timestampToTime(row.expire)) +
                                " "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "item_id", label: _vm.$t("items") },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.articleList.findIndex(function(item) {
                                    return item.id == row.item_id
                                  }) > -1
                                    ? _vm.articleList.find(function(item) {
                                        return item.id == row.item_id
                                      }).kind
                                    : row.item_id
                                )
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "num", label: _vm.$t("quantity") }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }